import React from 'react';
import { Navigate } from 'react-router-dom';
interface ProtectedRouteProps {
  children: React.ReactNode;
}
export function ProtectedRoute({
  children
}: ProtectedRouteProps) {
  const stored = localStorage.getItem('betiq_session');
  if (!stored) {
    return <Navigate to="/" replace data-id="element-10" />;
  }
  try {
    const session = JSON.parse(stored);
    // If it's a 5-day code, check expiration
    if (session.type === '5dias' && session.expiresAt) {
      const expiresAt = new Date(session.expiresAt).getTime();
      if (Date.now() >= expiresAt) {
        localStorage.removeItem('betiq_session');
        return <Navigate to="/" replace data-id="element-11" />;
      }
    }
    return <>{children}</>;
  } catch {
    localStorage.removeItem('betiq_session');
    return <Navigate to="/" replace data-id="element-12" />;
  }
}